import { render, staticRenderFns } from "./WordpressDisplayContent.vue?vue&type=template&id=407a8745&"
import script from "./WordpressDisplayContent.vue?vue&type=script&lang=js&"
export * from "./WordpressDisplayContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports